<div [@routerTransition]>
    <sub-header [title]="'PaymentTypes' | localize" [description]="'PaymentTypesHeaderInfo' | localize">
        <div role="actions">
            <div class="btn-group" dropdown placement="button right">
                <button
                    id="dropdownButtonExcelOperations"
                    dropdownToggle
                    type="button"
                    class="btn btn-outline btn-outline-success btn-active-light-success dropdown-toggle me-1"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    aria-controls="dropdownMenuExcelOperations"
                >
                    <i class="far fa-file-excel btn-md-icon"></i>
                    <span class="d-none d-md-inline-block">
                        {{ 'ExcelOperations' | localize }}
                    </span>
                </button>
                <ul
                    id="dropdownMenuExcelOperations"
                    class="dropdown-menu dropdown-menu-right dropdown-excel-operations"
                    role="menu"
                    *dropdownMenu
                    aria-labelledby="dropdownButtonExcelOperations"
                >
                    <li role="menuitem">
                        <a
                            class="dropdown-item text-gray-900"
                            id="ExportPaymentTypesToExcelButton"
                            (click)="this.showExcelColumnSelectionModal()"
                            href="javascript:;"
                        >
                            <i class="fa fa-download me-2 mt-1 text-gray-900" style="font-size: 1rem"></i>
                            {{ 'ExportToExcel' | localize }}
                        </a>
                    </li>

                    <li *ngIf="'Pages.PaymentTypes.Create' | permission" role="menuitem">
                        <a href="javascript:;" class="no-padding">
                            <span class="fileinput-button">
                                <p-fileUpload
                                    mode="basic"
                                    customUpload="true"
                                    name="ExcelFileUpload"
                                    #ExcelFileUpload
                                    maxFileSize="10000000"
                                    auto="auto"
                                    accept=".csv,.xls,.xlsx"
                                    (uploadHandler)="uploadExcel($event)"
                                    (onError)="onUploadExcelError()"
                                    chooseLabel="{{ 'ImportFromExcel' | localize }}"
                                ></p-fileUpload>
                            </span>
                        </a>
                    </li>
                </ul>
            </div>

            <button
                id="btn_create_paymentType"
                *ngIf="'Pages.PaymentTypes.Create' | permission"
                (click)="createPaymentType()"
                class="btn btn-primary blue"
            >
                <i class="fa fa-plus"></i>
                {{ l('CreateNewPaymentType') }}
            </button>
        </div>
    </sub-header>
    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <form class="form" autocomplete="off">
                    <div>
                        <div class="row align-items-center">
                            <div class="col-xl-12">
                                <div class="my-3">
                                    <div class="input-group mb-3">
                                        <input
                                            [(ngModel)]="filterText"
                                            (ngModelChange)="getPaymentTypes()"
                                            name="filterText"
                                            autoFocus
                                            type="text"
                                            class="form-control"
                                            [placeholder]="l('SearchWithThreeDot')"
                                        />
                                        <button class="btn btn-primary" type="submit" (click)="getPaymentTypes()">
                                            <i class="flaticon-search-1"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" [hidden]="!advancedFiltersAreShown">
                            <div class="col-md-12"></div>

                            <div class="col-md-3">
                                <div class="my-3">
                                    <label class="form-label" for="ChartOfAccountNameFilter">
                                        ({{ l('ChartOfAccount') }}) {{ l('Name') }}
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="ChartOfAccountNameFilter"
                                        name="chartOfAccountNameFilter"
                                        [(ngModel)]="chartOfAccountNameFilter"
                                    />
                                </div>
                            </div>
                            <div class="col-md-12 mt-5">
                                <button
                                    (click)="resetFilters()"
                                    class="btn btn-secondary btn-sm"
                                    id="btn-reset-filters"
                                >
                                    Reset
                                </button>
                            </div>
                        </div>
                        <div class="row my-4">
                            <div class="col-sm-12">
                                <span
                                    class="clickable-item text-muted"
                                    *ngIf="!advancedFiltersAreShown"
                                    (click)="advancedFiltersAreShown = !advancedFiltersAreShown"
                                >
                                    <i class="fa fa-angle-down"></i>
                                    {{ l('ShowAdvancedFilters') }}
                                </span>

                                <span
                                    class="clickable-item text-muted"
                                    *ngIf="advancedFiltersAreShown"
                                    (click)="advancedFiltersAreShown = !advancedFiltersAreShown"
                                >
                                    <i class="fa fa-angle-up"></i>
                                    {{ l('HideAdvancedFilters') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table
                            #dataTable
                            (onLazyLoad)="getPaymentTypes($event)"
                            [value]="primengTableHelper.records"
                            rows="{{ primengTableHelper.defaultRecordsCountPerPage }}"
                            [paginator]="false"
                            tableStyleClass="table table-bordered table-hover"
                            [lazy]="true"
                            [scrollable]="true"
                            ScrollWidth="100%"
                            [tableStyle]="{ 'min-width': '50rem' }"
                            [resizableColumns]="primengTableHelper.resizableColumns"
                        >
                            <ng-template pTemplate="header">
                                <tr>
                                    <th
                                        style="width: 5%"
                                        [hidden]="!isGrantedAny('Pages.PaymentTypes.Edit', 'Pages.PaymentTypes.Delete')"
                                    >
                                        {{ l('Actions') }}
                                    </th>
                                    <th style="width: 150px" pSortableColumn="name">
                                        {{ l('Name') }}
                                        <p-sortIcon field="paymentType.name"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="sortOrder">
                                        {{ l('SortOrder') }}
                                        <p-sortIcon field="paymentType.sortOrder"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                                <tr>
                                    <td
                                        style="width: 5%"
                                        [hidden]="!isGrantedAny('Pages.PaymentTypes.Edit', 'Pages.PaymentTypes.Delete')"
                                    >
                                        <div class="btn-group dropdown" dropdown container="body">
                                            <button class="dropdown-toggle btn btn-sm btn-primary" dropdownToggle>
                                                <i class="fa fa-cog"></i>
                                                <span class="caret"></span>
                                                
                                            </button>
                                            <ul class="dropdown-menu" *dropdownMenu>
                                                <li>
                                                    <a
                                                        href="javascript:;"
                                                        *ngIf="permission.isGranted('Pages.PaymentTypes.Edit')"
                                                        class="dropdown-item"
                                                        (click)="
                                                            createOrEditPaymentTypeModal.show(record.paymentType.id)
                                                        "
                                                    >
                                                        {{ l('Edit') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        class="dropdown-item"
                                                        href="javascript:;"
                                                        *ngIf="permission.isGranted('Pages.PaymentTypes.Delete')"
                                                        (click)="deletePaymentType(record.paymentType)"
                                                    >
                                                        {{ l('Delete') }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Name') }}</span>
                                        {{ record.paymentType.name }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('SortOrder') }}</span>
                                        {{ record.paymentType.sortOrder }}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ l('NoData') }}
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator
                                [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                #paginator
                                (onPageChange)="getPaymentTypes($event)"
                                [totalRecords]="primengTableHelper.totalRecordsCount"
                                [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                [showCurrentPageReport]="true"
                                [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "
                            ></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>
    <createOrEditPaymentTypeModal
        #createOrEditPaymentTypeModal
        (modalSave)="getPaymentTypes()"
    ></createOrEditPaymentTypeModal>

    <excel-column-selection-modal
        (modalSave)="exportToExcel($event)"
        #excelColumnSelectionModal
    ></excel-column-selection-modal>
</div>
